import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import AdminPage from "../pages/admin/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/admin", element: <AdminPage /> },
  { path: "*", element: <NotFound /> },
];

export default routes;
